<script>
  import user_image from '@/assets/img/placeholder_user.svg'
  import thumb2 from '@/assets/img/placeholder_thumb2.svg'
  import logo from '@/assets/img/placeholder_logo.svg'
  import Recordset from '@/providers/api/Recordset'

  export function imageUrl(image, size = 'upload') {
    var thumb;
    if (!isNaN(Number(size)) && image.thumbnails) {//get thumb
      thumb = image.thumbnails.pluck(size);
    } else if (typeof size === 'object' && size instanceof Recordset && size._type === 'thumbnails') {
      thumb = size;
    } else {
      thumb = image;
    }
    if (!thumb) {
      return '';
    }
    var path = thumb.path || '';
    return ENV.API_LOCATION.rtrim('/') + '/' + path.ltrim('/') + thumb.name;
  }

  const ItemImage = {
    props: {
      item: {required: true},
      default: {required: false},
      expandable: {default: false},
      size: {default: 'original'},
    },
    data () {return {
      reloadeditem: false,
    }},
    render (el) {
      var figureoptions = {
        class: 'image',
        style: {},
        directives: [],
      };
      if (this.expandable && this.image) {
        figureoptions.style.cursor = 'pointer';
        figureoptions.directives.push({
          name: 'help',
          value: el => el(ItemImage, {props: {
            expandable: false,
            item: this.item,
            size: 'original',
          }}),
        });
      }
      var imgoptions = {
        class: 'image',
        attrs: {
          src: this.src,
          alt: this.alt,
        }
      };
      if (!this.image || !this.asyncsrc) {
        imgoptions.class += ' placeholder';
        if (Array.isArray(this.size)) {
          var [width, height] = this.size;
          var padding = height / width * 100;
          figureoptions.class += ' placeholder-fixed';
          figureoptions.style['padding-top'] = padding + '%';
        }
      }
      return el('figure', figureoptions, [
        el('img', imgoptions),
        this.$slots.default,
      ]);
    },
    computed: {
      image () {
        var item;
        if (this.reloadeditem) {
          item = this.reloadeditem;
        } else {
          item = this.item;
        }
        if (!item) {return false;}
        if (typeof item === 'object' && !(item instanceof Recordset)) {
          if (Array.isArray(item) && item.length) {
            item = item[0];
          }
          var type = 'unknown';
          if (item.hasOwnProperty('path') && item.hasOwnProperty('extension')) {
            type = 'images';
          }
          item = new Recordset(type, item);
        }

        if ((item._type === 'images' || item.hasOwnProperty('thumbnails')) && item.length) {
          return item.pluck(0);
        } else if (item.images && item.images.length) {
          return item.images.pluck(0);
        } else if (
          item instanceof Recordset &&
          item._type !== 'images' &&
          item._type !== 'thumbnails' &&
          !item.hasOwnProperty('thumbnails') &&
          !item.hasOwnProperty('images') &&
          item.id
        ) {
          this.api.get(item._type + '/' + item.id + '?include=images')
            .then(r => this.reloadeditem = r)
          ;
          return false;
        } else {
          return false;
        }
      },
      alt () {
        if (this.image) {
          return this.image.title;
        } else {
          return '';
        }
      },
      src () {
        if (this.asyncsrc) {
          return this.asyncsrc;
        } else {
          switch (this.default) {
            case 'logo':
              return logo;
            case 'user':
              return user_image;
            case 'thumb2':
            default:
              return thumb2;
          }
          return '';
        }
      },
    },
    asyncComputed: {
      asyncsrc: {
        get () {
          //function for filtering out correct sized thumb
          var getaccepted = function (img, w, h) {
            if (img.thumbnails) {
              var accepted = img.thumbnails
                .filter(t => Number(t.size_x) === w && Number(t.size_y) === h)
              ;
              if (accepted.length) {
                return imageUrl(img, accepted.pluck(0));
              }
            }
          };

          if (Array.isArray(this.size)) {
            var [width, height] = this.size;
            var accepted = getaccepted(this.image, width, height);
            if (accepted) {
              return Promise.resolve(accepted);
            } else if (this.image.id) {
              //reload image (to load possible new thumbnails)
              return this.api
                .get('images/' + this.image.id + '?include=thumbnails')
                .then(img => {
                  //check for thumbnail (again)
                  if (getaccepted(img, width, height)) {
                    return getaccepted(img, width, height);
                  } else {
                    //generate new thumbnail
                    return this.api
                      .post('thumbnails', {
                        images_id: this.image.id,
                        size_x: width,
                        size_y: height,
                        quality: 80,  //Let's say 80 is good enough
                      })
                      //reload image
                      .then(() => this.api.get('images/' + this.image.id))
                      //check for thumbnail (again)
                      .then(img => getaccepted(img, width, height) || imageUrl(this.image))
                    ;
                  }
                })
                .catch(e => {
                  console.log('thumbnail generate error', e);
                  return imageUrl(this.image);
                })
              ;
            }
          }
          return Promise.resolve(imageUrl(this.image, this.size));
        },
        watch () {
          this.image;
        },
      }
    },
  }

  export default ItemImage;
</script>

<style lang="scss" scoped>
  .placeholder-fixed {
    position: relative;
    > img.placeholder {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 0 !important;
      max-width: 75%;
      max-height: 75%;
    }
  }
  .image {
    background: $body-bg;
    img:not(.placeholder) {
      width: 100%;
    }
    .placeholder {
      padding: 25%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/display/ItemImage.vue